export const GET_METHOD = 'GET';
export const POST_METHOD = 'POST';
export const DEFAULT_METHOD = 'get';
export const CSRF_CONFIG = {
  'X-XSRF-TOKEN': 'qcintl-intl-zones',
};
